import React from "react";

const SecondHalfLeave = ({style = {}, size = "36", className = "", fill="none", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M17 34h2c.39-.048.781-.09 1.17-.146 3.207-.459 6.036-1.748 8.45-3.908 2.751-2.463 4.471-5.519 5.13-9.159.107-.59.167-1.19.25-1.787v-2c-.049-.39-.09-.782-.146-1.172-.504-3.487-1.973-6.505-4.443-9.02-2.395-2.44-5.284-3.968-8.656-4.562-.581-.103-1.17-.165-1.756-.246h-2c-.545.071-1.093.124-1.633.216-2.994.513-5.645 1.76-7.917 3.776-2.798 2.48-4.546 5.563-5.203 9.251-.104.582-.165 1.17-.246 1.757v2c.018.08.046.16.052.241.187 2.458.89 4.76 2.169 6.865 2.538 4.175 6.21 6.743 11.024 7.649.58.11 1.17.164 1.754.245zm1.004-29.328c7.365.008 13.338 5.99 13.322 13.34A13.33 13.33 0 0118.01 31.328c-7.35.015-13.334-5.963-13.337-13.325-.003-7.36 5.975-13.337 13.331-13.33z"
            fill="#1E2538"
        />
        <path className="u_fill"
            d="M17.671 18.009l-.001 9.656c0 .298.02.583.24.815.227.24.512.286.827.281a10.786 10.786 0 0010.19-7.828c1.78-6.28-2.418-12.7-8.903-13.602a12.111 12.111 0 00-1.34-.09c-.656-.017-1.01.33-1.011.988-.004 2.114-.002 4.23-.002 6.344v3.436z"
            fill={fill}
        />
    </svg>
);

export default SecondHalfLeave;
